module.exports = __webpack_public_path__ + "img/GreatWoodBallPark.01a6be4d.png";